// extracted by mini-css-extract-plugin
export default {"login":"Login_login__vHD9J","title":"Login_title__BkVmE","content":"Login_content__C5hgp","forgot":"Login_forgot__dr48n"};